import Component from '../colorz/Component';
import getData from '@utils/html/getData';

export default class Filters extends Component {
	onInit(el) {
		this.el = el;
		this.btnOpen = this.el.querySelectorAll('.js-open-filters');
		this.btnClose = this.el.querySelectorAll('.js-close-filters');
		this.filtersWrapper = this.el.querySelector('.js-tabs-filters-sorting');
	}

	onReady() {
		if (this.btnOpen) {
			this.openFilters();

			this.btnClose.forEach((btn) => {
				btn.addEventListener('click', () => {
					this.closeFilters();
				});
			});
		}
	}

	openFilters() {
		this.btnOpen.forEach((btn) => {
			btn.addEventListener('click', () => {
				this.tab = getData(btn, 'tab');

				document.body.addEventListener('keydown', (e) => {
					if (e.key == 'Escape') {
						this.closeFilters();
						document.querySelector('#open-filters-mobile').focus();
					}
				});

				if (btn.classList.contains('active')) {
					this.closeFilters();
				} else {
					if (this.el.querySelector('.js-open-filters.active')) {
						this.el
							.querySelector('.js-open-filters.active')
							.setAttribute('aria-expanded', 'false');
						this.el
							.querySelector('.js-open-filters.active')
							.classList.remove('active');
					}

					btn.classList.add('active');
					this.filtersWrapper.classList.add('active');
					this.filtersWrapper.setAttribute('data-tab-active', this.tab);
					btn.setAttribute('aria-expanded', 'true');

					// Accessibility: Remove inert and aria-hidden when opening
					this.filtersWrapper.removeAttribute('inert');
					this.filtersWrapper.setAttribute('aria-hidden', 'false');

					if (this.tab == 'filters') {
						var containerToTrapFocusOn = document.querySelector(
							'#filters-tab-mobile',
						);
						var focusElement = document.querySelector('#filters-tab-mobile');

						// Accessibility: Make filters tab accessible and sorting tab inaccessible
						containerToTrapFocusOn.removeAttribute('inert');
						containerToTrapFocusOn.setAttribute('aria-hidden', 'false');
						containerToTrapFocusOn.classList.remove('u-hidden'); // ← AJOUT

						document
							.querySelector('#sorting-tab-mobile')
							.setAttribute('inert', '');
						document
							.querySelector('#sorting-tab-mobile')
							.setAttribute('aria-hidden', 'true');
						document
							.querySelector('#sorting-tab-mobile')
							.classList.add('u-hidden'); // ← AJOUT
					} else if (this.tab == 'sorting') {
						var containerToTrapFocusOn = document.querySelector(
							'#sorting-tab-mobile',
						);
						var focusElement = document.querySelector('#sorting-tab-mobile');

						// Accessibility: Make sorting tab accessible and filters tab inaccessible
						containerToTrapFocusOn.removeAttribute('inert');
						containerToTrapFocusOn.setAttribute('aria-hidden', 'false');
						containerToTrapFocusOn.classList.remove('u-hidden'); // ← AJOUT

						document
							.querySelector('#filters-tab-mobile')
							.setAttribute('inert', '');
						document
							.querySelector('#filters-tab-mobile')
							.setAttribute('aria-hidden', 'true');
						document
							.querySelector('#filters-tab-mobile')
							.classList.add('u-hidden'); // ← AJOUT
					}

					this.trapFocus(containerToTrapFocusOn);
					const firstFocusableElement = focusElement.querySelector(
						'summary, input, button, a, [tabindex]:not([tabindex="-1"])',
					);
					if (firstFocusableElement) {
						firstFocusableElement.focus();
					} else {
						focusElement.focus();
					}
				}
			});
		});
	}

	trapFocus(container) {
		const focusableSelectors =
			'summary, input:not([tabindex="-1"]), button:not([tabindex="-1"]), a:not([tabindex="-1"]), label[tabindex="0"], [tabindex]:not([tabindex="-1"])';
		const focusableElements = Array.from(
			container.querySelectorAll(focusableSelectors),
		);
		if (!focusableElements.length) return;

		this.removeTrapFocus();
		this.focusTrapHandler = (e) => {
			if (e.key !== 'Tab') return;
			const currentIndex = focusableElements.indexOf(document.activeElement);
			if (currentIndex === -1) return;
			e.preventDefault();
			const nextIndex = e.shiftKey
				? (currentIndex - 1 + focusableElements.length) %
				  focusableElements.length
				: (currentIndex + 1) % focusableElements.length;
			focusableElements[nextIndex].focus();
		};
		document.addEventListener('keydown', this.focusTrapHandler);
	}

	removeTrapFocus() {
		if (this.focusTrapHandler) {
			document.removeEventListener('keydown', this.focusTrapHandler);
			this.focusTrapHandler = null;
		}
	}

	closeFilters() {
		this.removeTrapFocus();
		this.filtersWrapper.classList.remove('active');
		this.filtersWrapper.removeAttribute('data-tab-active');

		// Accessibility: Add back inert and aria-hidden when closing
		this.filtersWrapper.setAttribute('inert', '');
		this.filtersWrapper.setAttribute('aria-hidden', 'true');

		// Accessibility: Make both tabs inaccessible when closed
		document.querySelector('#filters-tab-mobile').setAttribute('inert', '');
		document
			.querySelector('#filters-tab-mobile')
			.setAttribute('aria-hidden', 'true');
		document.querySelector('#filters-tab-mobile').classList.add('u-hidden'); // ← AJOUT

		document.querySelector('#sorting-tab-mobile').setAttribute('inert', '');
		document
			.querySelector('#sorting-tab-mobile')
			.setAttribute('aria-hidden', 'true');
		document.querySelector('#sorting-tab-mobile').classList.add('u-hidden'); // ← AJOUT

		this.btnOpen.forEach((btn) => {
			btn.classList.remove('active');
			btn.setAttribute('aria-expanded', 'false');
		});
	}
}
